// extracted by mini-css-extract-plugin
export default {"icon_container":"style_icon_container__Ar0vJ"};